import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_ICalendarEvent } from '../Type/Type.hive'

export function IDB_calendarEventRead(id: string | number) {
    return IDB_rowRead<Type_ICalendarEvent>(IDB_globalDb, 'calendar_events', id)
}

export function IDB_calendarEventsDelete(ids: Array<string | number>) {
    return IDB_rowsDelete(IDB_globalDb, 'calendar_events', ids)
}

export function IDB_calendarEventsReadAll() {
    return IDB_rowsReadAll<Type_ICalendarEvent>(IDB_globalDb, 'calendar_events')
}

export function IDB_calendarEventsWrite(calendarEvents: Type_ICalendarEvent[]) {
    return IDB_rowsWrite(IDB_globalDb, 'calendar_events', calendarEvents)
}
